import { c as _c } from "react/compiler-runtime";
import React, { type ReactElement } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Collapse, ListItem } from '@mui/material';
import { StyledBoxChevronContainer, StyledGridFooterActionItemsContainer, StyledListFooterContainer, StyledListItemNavItem } from './styles';
import { type NavFooterProps, type AccountActions } from './types';
import { ChevronDownIcon } from '../icons/ChevronDownIcon';
import { ChevronUpIcon } from '../icons/ChevronUpIcon';
import { styled } from '../../utils/styled';
import Grid from '../Grid';
const NavFooter = t0 => {
  const $ = _c(37);
  const {
    sideNavProps,
    accountSection: AccountSection,
    navFooterActions: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const navFooterActions = t2;
  let t3;
  if ($[2] !== sideNavProps) {
    t3 = () => {
      sideNavProps.toggleNavFooter();
    };
    $[2] = sideNavProps;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClick = t3;
  let t4;
  if ($[4] !== navFooterActions) {
    t4 = navFooterActions.length > 0 ? <StyledGridFooterActionItemsContainer>{navFooterActions.map(_temp)}</StyledGridFooterActionItemsContainer> : null;
    $[4] = navFooterActions;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = sideNavProps.isNavFooterOpen;
  let t6;
  if ($[6] !== AccountSection.AvatarComponent) {
    t6 = <ListItemIcon>{AccountSection.AvatarComponent}</ListItemIcon>;
    $[6] = AccountSection.AvatarComponent;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      variant: "h5"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      variant: "body3"
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== AccountSection.email || $[11] !== AccountSection.fullName) {
    t9 = <ListItemText primary={AccountSection.fullName} primaryTypographyProps={t7} secondary={AccountSection.email} secondaryTypographyProps={t8} />;
    $[10] = AccountSection.email;
    $[11] = AccountSection.fullName;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== sideNavProps.isNavFooterOpen) {
    t10 = sideNavProps.isNavFooterOpen ? <ChevronDownIcon /> : <ChevronUpIcon />;
    $[13] = sideNavProps.isNavFooterOpen;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== sideNavProps.isNavBarOpen || $[16] !== t10) {
    t11 = <StyledBoxChevronContainer isNavBarOpen={sideNavProps.isNavBarOpen}>{t10}</StyledBoxChevronContainer>;
    $[15] = sideNavProps.isNavBarOpen;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== handleClick || $[19] !== t11 || $[20] !== t6 || $[21] !== t9) {
    t12 = <StyledListItemNavItem><ListItemButton onClick={handleClick}>{t6}{t9}{t11}</ListItemButton></StyledListItemNavItem>;
    $[18] = handleClick;
    $[19] = t11;
    $[20] = t6;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = sideNavProps.isNavFooterOpen;
  let t14;
  if ($[23] !== AccountSection.accountActionslist) {
    t14 = AccountSection.accountActionslist.map(_temp2);
    $[23] = AccountSection.accountActionslist;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14) {
    t15 = <List component="div">{t14}</List>;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== sideNavProps.isNavFooterOpen || $[28] !== t15) {
    t16 = <Collapse in={t13}>{t15}</Collapse>;
    $[27] = sideNavProps.isNavFooterOpen;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== sideNavProps.isNavFooterOpen || $[31] !== t12 || $[32] !== t16) {
    t17 = <StyledListFooterContainer open={t5} aria-labelledby="nested-list-subheader">{t12}{t16}</StyledListFooterContainer>;
    $[30] = sideNavProps.isNavFooterOpen;
    $[31] = t12;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17 || $[35] !== t4) {
    t18 = <>{t4}{t17}</>;
    $[34] = t17;
    $[35] = t4;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
};
const FooterMenuItem = t0 => {
  const $ = _c(9);
  const {
    label,
    handleClick
  } = t0;
  const [isHovered, setIsHovered] = React.useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsHovered(true);
    };
    t2 = () => {
      setIsHovered(false);
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ListItemIcon><Grid width="40px" /></ListItemIcon>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isHovered ? "h5" : "body2";
  let t5;
  if ($[3] !== t4) {
    t5 = {
      variant: t4
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== handleClick || $[6] !== label || $[7] !== t5) {
    t6 = <StyledListItemFooterItem onMouseEnter={t1} onMouseLeave={t2}><ListItemButton>{t3}<ListItemText primary={label} primaryTypographyProps={t5} onClick={handleClick} /></ListItemButton></StyledListItemFooterItem>;
    $[5] = handleClick;
    $[6] = label;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
const StyledListItemFooterItem = styled(ListItem)(() => ({
  height: '40px',
  '.MuiButtonBase-root': {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}));
export default NavFooter;
function _temp(action) {
  return <StyledListItemNavItem key={action.label}><ListItemButton onClick={action.handleClick}><ListItemIcon>{action.IconComponent}</ListItemIcon><ListItemText primary={action.label} primaryTypographyProps={{
        variant: "h5"
      }} /></ListItemButton></StyledListItemNavItem>;
}
function _temp2(item, index) {
  return <FooterMenuItem key={`${item.label}-${index}`} {...item} />;
}